import { Button, Tooltip } from 'antd';
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import { useState } from 'react';
import { FileTextOutlined } from '@ant-design/icons';

type IProps = {
  excelName: string;
  excelTableHead: string[];
  excelData: any[];
  description?: string; // Add this new prop for meal description
  nameOfBtn?: string;
};

const DownloadExcelReport = ({
  excelName,
  excelTableHead,
  excelData,
  description = '', // Set a default empty value for the meal description
  nameOfBtn = 'Excel Report',
}: IProps) => {
  const workbook = new Excel.Workbook();

  const saveExcel = async () => {
    try {
      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(`${excelName}`);

      // Add meal description as title
      const descriptionRow = worksheet.addRow([description]);
      descriptionRow.font = { bold: true, size: 14 };
      descriptionRow.alignment = { horizontal: 'center' };
      worksheet.mergeCells(`A1:${String.fromCharCode(65 + excelTableHead.length - 1)}1`);

      // Add table header row
      const titleRow = worksheet.addRow(excelTableHead);
      titleRow.eachCell((cell: any) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
      });

      // Set column widths
      worksheet.columns.forEach((column: any) => {
        column.width = 25; // Set column width to 25 units
      });

      // Populate data rows
      excelData.forEach((rowData: any) => {
        const values = excelTableHead.map((header: any) => rowData[header]);
        const row = worksheet.addRow(values);

        // Set row height
        row.height = 25; // Set row height to 25 units

        // Apply cell formatting
        row.eachCell((cell: any) => {
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
        });
      });

      const excelDataGenerate = await workbook.xlsx.writeBuffer();
      // download the processed file
      saveAs(new Blob([excelDataGenerate]), `${excelName}.xlsx`);
    } catch (error: any) {
      console.error('Something Went Wrong', error.message);
    }
  };

  return (
    <div>
      <Button
        type='primary'
        onClick={() => {
          if (excelData?.length) saveExcel();
        }}
      >
        <FileTextOutlined />
        {nameOfBtn}
      </Button>
    </div>
  );
};

export default DownloadExcelReport;
